(() => {
  const mobileMq = window.matchMedia('(max-width: 767px)');

  const initDrawers = (scope = document) => {
    scope.querySelectorAll('[data-gostosso-product-article]').forEach((article) => {
      const drawers = [...article.querySelectorAll('[data-gostosso-drawer]')];

      const setDrawerState = (drawer, open) => {
        const toggle = drawer.querySelector(':scope > .gostosso-product-article__toggle');
        const panel = drawer.querySelector(':scope > .gostosso-product-article__body');
        if (!toggle || !panel) return;

        toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
        panel.hidden = !open;
      };

      drawers.forEach((drawer) => {
        const toggle = drawer.querySelector(':scope > .gostosso-product-article__toggle');
        if (!toggle || toggle.dataset.gostossoDrawerBound === 'true') return;
        toggle.dataset.gostossoDrawerBound = 'true';

        toggle.addEventListener('click', () => {
          if (!mobileMq.matches) return;
          const isOpen = toggle.getAttribute('aria-expanded') === 'true';
          setDrawerState(drawer, !isOpen);
        });
      });

      if (article.dataset.drawerViewportReady !== 'true') {
        article.dataset.drawerViewportReady = 'true';

        const syncViewport = () => {
          drawers.forEach((drawer) => setDrawerState(drawer, !mobileMq.matches));
        };

        mobileMq.addEventListener?.('change', syncViewport);
        syncViewport();
      }
    });
  };

  const initVideo = (scope = document) => {
    scope.querySelectorAll('.gostosso-pdp-video-card').forEach((card) => {
      const progress = card.querySelector('[data-gostosso-video-progress]');
      const soundButton = card.querySelector('[data-gostosso-video-sound]');
      if (!progress || progress.dataset.ready === 'true') return;
      progress.dataset.ready = 'true';

      const bindVideo = (video) => {
        if (!video || video.dataset.gostossoPlayerBound === 'true') return false;
        video.dataset.gostossoPlayerBound = 'true';

        video.loop = true;
        video.autoplay = true;
        video.playsInline = true;

        // Prefer sound ON by default. Browsers may block autoplay with sound;
        // if they do, fall back to muted autoplay, and user can unmute via the icon.
        video.removeAttribute('muted');
        video.defaultMuted = false;
        video.muted = false;
        video.volume = 1;

        const syncProgress = () => {
          if (!video.duration || !isFinite(video.duration)) return;
          const pct = Math.max(0, Math.min(100, (video.currentTime / video.duration) * 100));
          progress.value = String(pct);
          progress.style.setProperty('--gostosso-video-progress', pct + '%');
        };

        const syncSound = () => {
          card.classList.toggle('is-video-muted', video.muted);
          if (soundButton) soundButton.setAttribute('aria-label', video.muted ? 'Unmute video' : 'Mute video');
        };

        progress.addEventListener('input', (event) => {
          event.stopPropagation();
          if (!video.duration || !isFinite(video.duration)) return;
          video.currentTime = (parseFloat(progress.value) / 100) * video.duration;
          syncProgress();
        });

        video.addEventListener('click', () => {
          if (video.paused) video.play().catch(() => {});
          else video.pause();
        });

        soundButton?.addEventListener('click', (event) => {
          event.preventDefault();
          event.stopPropagation();

          const shouldMute = !video.muted;

          if (shouldMute) {
            video.muted = true;
            video.defaultMuted = true;
            video.setAttribute('muted', '');
          } else {
            video.removeAttribute('muted');
            video.defaultMuted = false;
            video.muted = false;
            video.volume = 1;
          }

          syncSound();
          video.play().catch(() => {});
        });

        ['timeupdate', 'loadedmetadata', 'durationchange'].forEach((name) => {
          video.addEventListener(name, syncProgress);
        });
        video.addEventListener('volumechange', syncSound);

        video.addEventListener('ended', () => {
          video.currentTime = 0;
          video.play().catch(() => {});
        });

        syncProgress();
        syncSound();

        const startWithSound = () => {
          video.removeAttribute('muted');
          video.defaultMuted = false;
          video.muted = false;
          video.volume = 1;
          video.currentTime = 0;
          syncSound();
          return video.play();
        };

        startWithSound().catch(() => {
          // Browsers can block audible autoplay. Keep the video at the beginning,
          // then start from 0 with sound on the first real user interaction.
          video.pause();
          video.currentTime = 0;
          video.muted = false;
          video.defaultMuted = false;
          video.removeAttribute('muted');
          syncSound();

          const unlockAudio = () => {
            startWithSound().catch(() => {});
            window.removeEventListener('pointerdown', unlockAudio, true);
            window.removeEventListener('keydown', unlockAudio, true);
            window.removeEventListener('touchstart', unlockAudio, true);
          };

          window.addEventListener('pointerdown', unlockAudio, true);
          window.addEventListener('keydown', unlockAudio, true);
          window.addEventListener('touchstart', unlockAudio, true);
        });
        return true;
      };

      if (!bindVideo(card.querySelector('video'))) {
        const observer = new MutationObserver(() => {
          if (bindVideo(card.querySelector('video'))) observer.disconnect();
        });
        observer.observe(card, { childList: true, subtree: true });
      }
    });
  };

  const init = (scope = document) => {
    initDrawers(scope);
    initVideo(scope);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init());
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();